import { render } from "./order.vue?vue&type=template&id=0abbf566"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"

import "./order.vue?vue&type=style&index=0&id=0abbf566&lang=less"
script.render = render

export default script